/**
 * It's suggested to configure the RESTful endpoints in this file
 * so that there is only one source of truth, future update of endpoints
 * could be done from here without refactoring on multiple places throughout the app
 */
const API = {
  auth: {
    login: '/auth/login',
    currentUser: '/auth/user',
    logout: '/auth/logout',
    activity: '/auth/activity',
  },
  services: {
    root: '/services/',
    datesAvailability: 'dates-availability',
    resultsVerification: 'results-verification',
    servicesHistorySettings: '/services-history-settings',
    mobileFormField: 'service-form-field',
    evidencesSignedPost: 'evidences-signed-post',
    attachmentsSignedPost: 'attachments-signed-post',
    mobileForm: 'service-form',
    status: 'status',
    reviewForm: 'review-form',
    tags: 'tags',
    notifications: 'notifications',
    reports: 'reports',
  },
  serviceTypes: {
    root: '/service-types/',
    notifications: 'notifications',
    selfScheduling: 'self-scheduling',
    variables: 'variables',
    pdfTemplatesSettings: 'pdf-templates-settings',
    incidentsSequencePrefix: 'incidents-sequence-prefix',
    radioFields: 'radio-fields',
  },
  companies: {
    root: '/companies/',
    contacts: 'contacts',
    variables: 'variables',
  },
  incidentForms: {
    root: '/incidents-forms/',
  },
  dictionaries: {
    root: '/dictionaries/',
    commonTerms: 'common-terms',
    profileNames: 'profile-names',
  },
  serviceStatus: {
    root: '/service-status/',
  },
  users: {
    root: '/users/',
    profileCounts: 'profile-counts',
    advancedAvailability: 'advanced-availability',
    password: 'password',
    changeStatus: 'change-status',
    devices: 'devices',
    geoTracks: 'geo-tracks',
    geoLocation: 'geo-location',
    latest: 'latest',
    route: 'route',
    nearest: 'nearest',
  },
  finalCustomers: {
    root: '/final-customers/',
    identification: '/identification/',
    settings: 'final-customer-settings',
  },
  interoperableData: {
    root: '/interoperable-data/',
    bloodTypes: 'blood-types',
    documentTypes: 'document-types',
    biologicalSexes: 'biological-sexes',
    healthInsurances: 'health-insurances',
    countries: 'countries',
    cities: 'cities',
    departments: 'departments',
    regimes: 'regimes',
    scholarlyLevels: 'scholarly-levels',
    personConditions: 'person-conditions',
  },
  importData: {
    finalCustomers: 'final_customers/import',
    importCustomList: 'import-list-items/',
    customers: 'customers',
    saveCustomers: 'save',
    validateCustomer: 'validate',
  },
  accounts: {
    root: '/accounts',
    selectable: 'selectable',
    signedPost: 'menu-logo-signed-post',
    mobileSignedPost: 'mobile-logo-signed-post',
    validations: 'validations',
    checkPrefix: 'prefix-availability',
    publicRegistration: 'public-registration',
    profile: 'account-profile',
  },
  admin: {
    root: '/admin',
    account: 'account',
    sessions: 'sessions',
  },
  selfScheduling: {
    root: '/self-scheduling',
    mainPage: 'main-page',
    banner: 'banner',
    logo: 'logo',
    assignableUsers: 'assignable-users',
    finalCustomerFields: 'final-customer-fields',
  },
  appointmentSelfScheduling: {
    root: '/appointment-self-scheduling',
    token: 'auth/login',
    landingPageData: 'landing-data',
    appointmentTypes: 'appointment-types',
    scheduleBlocks: 'schedule-blocks',
    headquarters: 'headquarters',
    finalCustomers: 'finalCustomers',
    patient: 'patient',
    cities: 'cities',
    departments: 'departments',
    countries: 'countries',
    regimes: 'health-insurance-regimes',
    healthInsurances: 'health-insurances',
    professionals: 'professionals',
    legalData: 'legal-data',
    terms: 'legal-terms',
    dataTreatment: 'data-treatment-policy',
    dictionary: 'dictionary',
    extendedForms: 'extended-forms',
    assets: 'assets',
    unavailableDates: 'unavailable-dates',
    bloodTypes: 'blood-types',
    patienSelfScheduleFields: 'patient/self-schedule-fields',
    customers: 'customers',
    paymentAmounts: 'payment-amounts',
    paymentProviders: 'payment-methods',
    appointments: 'appointments',
    awaitingList: 'awaiting-list',
    applications: 'applications',
    schedulesTimes: 'schedule-times',
    customLists: {
      root: 'custom-lists',
      listRoot: 'root',
      listItems: 'list-items',
    },
    fileUploads: {
      root: 'file-uploads',
      signedPost: 'signed-post',
    },
    reCaptcha: {
      root: 'recaptcha',
      validateV2: 'validation/v2',
    },
  },
  customLists: {
    root: '/custom-lists/',
    listItems: 'list-items',
    listRoot: 'root',
    duplicate: 'duplicate',
  },
  assets: {
    root: '/assets/',
    near: 'near/',
    scheduleTimes: 'schedule/',
    validator: '/xls_validator',
    validate: '/validate',
    assetsUploader: 'assets_uploader',
    save: '/save',
  },
  serviceAssetTypes: {
    root: '/asset-types',
  },
  fileUploads: {
    root: '/file-uploads',
    signedPost: 'signed-post',
  },
  utils: {
    root: '/utils',
    colors: 'colors',
    languages: 'languages',
    timezones: 'timezones',
  },
  specialties: {
    root: '/specialties',
  },
  applications: {
    root: '/applications',
    attachmentsSignedPost: 'attachments-signed-post',
  },
  headquarters: {
    root: '/headquarters',
    defaultHeadquarter: 'default-headquarter',
    lockedDates: 'locked-dates',
    headquarterLockedDates: '/headquarter-locked-dates',
  },
  workStations: {
    root: '/work-stations',
    current: '/work-stations/current',
  },
  workStationRecords: {
    root: '/work-station-records',
    checkIn: 'check-in',
    expire: 'expire',
  },
  workStationsSettings: {
    root: '/work-stations-settings',
  },
  scheduleTimes: {
    root: '/schedule-times',
  },
  availabilityLocks: {
    root: '/availability-locks',
    history: 'availability-locks/history',
    verify: '/availability-locks/schedule-verification',
  },
  servicesStatus: {
    root: '/service-status',
  },
  gadgetsHtml: {
    root: '/gadgets-html',
  },
  credentiaslApi: {
    root: '/credentials-api',
    apiToken: 'api-token',
  },
  availability: {
    root: '/availability',
  },
  serviceNoteTypes: {
    root: '/service-notes-types',
  },
  serviceCancellationReassons: {
    root: '/service-cancellation-reassons',
  },
  tagConditionConfigs: {
    root: '/tag-condition-configs',
  },
  serviceFinalCustomersTags: {
    root: '/final-customer-tags',
  },
  modules: {
    root: '/modules',
  },
  awaitingList: {
    root: '/patients-awaiting-list',
  },
  awaitingListSettings: {
    root: '/awaiting-list-settings',
  },
  whatsapp: {
    root: '/messaging',
    whatsapp: 'whatsapp',
    broadcastMessages: 'broadcast-messages',
  },
  whatsaapAcountConfig: {
    root: '/whatsapp-config',
    verificationToken: 'verification-token',
  },
  patientOverview: {
    root: '/patient-overview/',
  },
  legalTerms: {
    root: '/legal-data',
    terms: 'legal-terms',
    dataTreatment: 'data-treatment-policy',
  },

  pdfSettings: {
    root: '/pdf-settings',
    templates: '/pdf-templates',
  },
  pdfTemplatesSettings: {
    root: '/pdf-templates-settings',
  },

  accountProfile: {
    root: '/account-profile',
  },
  notes: {
    root: '/service-notes',
    attachments: 'attachments',
  },
  surveysGroups: {
    root: '/survey-groups',
  },
  surveys: {
    root: '/surveys',
  },
  surveyTemplates: {
    root: '/survey-templates',
  },
  surveysSent: {
    root: '/surveys-sent',
  },
  incidentsMap: {
    root: '/incidents-map',
    users: '/users',
  },
  supportChats: {
    root: '/support-chats',
    attachmentSignedPost: 'attachment-signed-post',
    chatMessages: 'chat-messages',
    updates: 'updates',
    supportChatSettings: 'support-chat-settings',
    transfer: 'transfer',
  },
  pendingsBoard: {
    root: '/services-board',
    settings: '/services-board/settings',
    userSettings: '/services-board/user-settings',
  },
  videoConsultation: {
    root: '/video-consultation',
    publicRoom: '/public-room',
  },
  videoCall: {
    root: '/incidents-video-call',
    signDocument: 'document-signature',
  },
  customViewsReports: {
    root: '/custom-views-reports',
  },
  quickAnswers: {
    root: '/quick-answers',
  },
  sequences: {
    root: '/sequences',
  },
  customReportsSettings: {
    root: '/custom-reports-settings/',
    count: 'count-by-user',
    byUser: 'by-user',
  },
  paymentsServices: {
    root: '/payments',
    paymentMethods: '/payment_methods',
    serviceTypeAmount: '/service_type_amount',
    createPayments: '/create_payment',
    checkPaymentStatus: '/check_payment_status',
    paymentNotification: '/payment_notification',
    paymentMethodsProviders: 'payment-methods-providers',
    createLinkPayment: '/payment_links/create',
    paymentLinkNotification: '/payment-link-notification',
    paymentLinks: '/payment_links',
    getLinkDetail: '/get_link_detail',
  },
  wppConversationsService: {
    payments: '/payments',
    paymentLinkNotification: 'payment-link-notification',
    supportChats: {
      root: '/support-chats',
      assignation: 'assignation',
      finalCustomer: 'final-customer',
      messages: 'messages',
      close: 'close',
      readMark: 'read-mark',
    },
    notifications: 'notifications',
    eventNotifications: 'event-notifications',
    reminder: 'incident-reminder/',
  },
  serviceChats: {
    root: '/incidents-chat',
    attachment: 'attachment',
    messagesHistory: 'messages-history',
  },
  documentSettings: {
    root: '/document-settings',
  },
  exportServices: {
    micita: 'standard',
    exportServices: 'export_services',
  },
  pdfReports: {
    report: 'report',
    batch: 'batch',
  },
  billing: {
    root: '/billing',
    account: '/account',
    certificate: '/certificate',
    resolutions: '/resolutions',
    items: '/items',
    companies: '/companies',
    invoice: '/invoice',
    invoices: '/invoices',
    invoiceCount: '/invoice-counts',
    invoiceFiles: '/invoice-files',
    invoiceXml: '/invoice-xml',
    sendNotification: '/send-notification',
    service: '/service',
    status: '/status',
    creditNotes: '/credit-notes',
    adjustmentNotes: '/adjustment-notes',
    creditNoteXml: '/xml',
    updateOptions: '/update-options',
    checkEnablement: '/check-enablement',
    changeEnvironment: '/change-environment',
  },
  archiveTemplates: {
    root: '/archive-templates',
  },
  inventory: {
    root: '/inventory',
    config: '/config',
    movementTypes: '/movement-types',
  },
  warehouses: {
    root: '/warehouses',
    stock: '/stock',
    enableForReception: 'enableForReception',
  },
  stock: {
    root: '/stock',
    counts: '/stock-counts',
    stocks: '/stocks',
    consolidate: '/stock/consolidate',
  },
  categories: {
    root: '/categories',
  },
  items: {
    root: '/items',
  },
  movements: {
    root: '/movements',
    inbound: '/inbound',
    transfer: '/transfer',
    outbound: '/outbound',
    adjustment: '/adjustment',
  },
  workFlows: {
    root: '/workflows',
  },
  topics: {
    root: '/topics',
    assigned: '/assigned',
  },
  suspensions: {
    root: 'suspensions/',
    finalCustomer: 'final-customer',
  },
  forms:{
    root:'/applications',
    draft: 'draft',
    flexibleValidation: 'flexible-validation',
    duplicate: 'duplicate',
    move: 'move',
  },
  tagTypes: {
    root: 'tag-types',
  },
  triggerTasks: {
    root: '/trigger-tasks',
  },
  flowTemplates: {
    root: '/flow-templates',
    conditions: '/conditions',
  },
};

export { API };
